import styled from 'styled-components';
import { pxToRem } from 'Styles/utils/utils';
import { TABLET_WIDTH } from 'Styles/variables/sizes';

export const Container = styled.div`
  border-radius: ${({ theme: { sizing } }) => sizing.fds_borderradius_L};
  background: ${({ theme: { colors } }) => colors.warning_100};
  width: 100%;
  max-width: 450px;

  @media screen and (max-width: ${TABLET_WIDTH}) {
    padding: 0;
    position: relative;
  }
`;

export const TabHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  text-transform: capitalize;
  font-weight: 500;
  color: ${({ theme: { colors } }) => colors.blue_2};
  svg {
    margin-right: 10px;
    width: 20px;
    height: 20px;
  }
  span {
    padding: ${pxToRem(4)} ${pxToRem(10)};
    text-align: center;
    justify-content: center;
    background: ${({ hasWarnings, theme: { colors } }) =>
      hasWarnings ? colors.orange_2 : colors.green_2};
    border-radius: 7px;
    font-size: 18px;
    line-height: 100%;
    color: white;
    display: flex;
    align-items: center;
    letter-spacing: 0.2px;
    margin-left: auto;
  }
`;
